import { Injectable } from '@angular/core';
import { LocaleService } from '@app/core/i18n';
import { ContentsMarketingFilter, ContentsService } from '@vestiaire/api-sdk-angular';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class MarketingFilterService {
  constructor(private contentsService: ContentsService, private localeService: LocaleService) {}

  getMarketingFilter(): Observable<ContentsMarketingFilter[]> {
    return this.contentsService
      .getMarketingFilters(this.localeService.getCountry(), this.localeService.getLanguage())
      .pipe(
        catchError(err => {
          if (err?.status === 404) {
            return of(undefined);
          }
          return throwError(err);
        }),
        map(({ data }) => data)
      );
  }
}
